/**
 * Dependencies.
 */
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import { TRACKING_STATUS as TrackingStatus } from '@/modules/tracking/constants';

/**
 * Component.
 */
@Component({
  name: 'choose-change-component'
})
export default class extends Vue {
  /**
   * Property `trackingStatus`.
   */
  trackingStatus = TrackingStatus;

  /**
   * Property `deliveryStatus`.
   */
  @Prop({ default: null })
  deliveryStatus: string;

  /**
   * Property `requestPendingTreatment`.
   */
  @Prop({ type: Object })
  requestPendingTreatment: {
    changeAddress?: boolean;
    changeDate?: boolean;
    changeDateAndAddress?: boolean;
  };

  /**
   * Property `orderType`.
   */
  @Prop({ default: null, type: String })
  orderType: string;

  /**
   * Property `maximumOfRequets`.
   */
  @Prop({ default: null, type: Number })
  maximumOfRequets: number;

  /**
   * Property `totalRequestsMade`.
   */
  @Prop({ default: null, type: Number })
  totalRequestsMade: number;

  /**
   * Getter `maximumRequestsReached`.
   */
  get maximumRequestsReached() {
    return this.totalRequestsMade >= this.maximumOfRequets;
  }

  /**
   * Getter `requestsLeft`.
   */
  get requestsLeft() {
    const total = this.maximumOfRequets - this.totalRequestsMade;

    return total > 0 ? total : 0;
  }

  /**
   * Getter `key`.
   */
  get key() {
    const { key = null } = this.$route.params || {};

    return key;
  }

  /**
   * Property `pendingAddressChange`.
   */
  get pendingAddressChange() {
    const { changeAddress = false, changeDateAndAddress = false } =
      this.requestPendingTreatment || {};

    return changeAddress || changeDateAndAddress;
  }

  /**
   * Property `pendingDayChange`.
   */
  get pendingDayChange() {
    const { changeDate = false, changeDateAndAddress = false } =
      this.requestPendingTreatment || {};

    return changeDate || changeDateAndAddress;
  }

  /**
   * Getter is status unsuccessful.
   */
  get isStatusUnsuccessful() {
    const { NOT_COLLECTED, NOT_DELIVERED } = this.trackingStatus;
    const { deliveryStatus: status } = this || {};

    return status === NOT_DELIVERED || status === NOT_COLLECTED;
  }

  /**
   * Getter is delivery.
   */
  get isDelivery() {
    return this.orderType === 'DELIVERY';
  }

  /**
   * Handle change address.
   */
  handleChangeAddress() {
    if (
      !this.pendingAddressChange &&
      !this.isStatusUnsuccessful &&
      !this.maximumRequestsReached
    ) {
      this.$router.push({
        name: 'SearchAddress',
        params: {
          key: this.key
        }
      });
    }
  }

  /**
   * Handle change day.
   */
  handleChangeDay() {
    if (!this.pendingDayChange && !this.maximumRequestsReached) {
      this.$emit('change-day');
    }
  }
}
